// register.js
import React from 'react';
import User from '../services/user';
import ReactPasswordStrength from 'react-password-strength';
import {Link} from 'react-router-dom';
import SVGInline from 'react-svg-inline';
import InputMask from 'react-input-mask';
import { Captcha } from './Captcha/captcha';
import { eventTracker } from '../helpers/ga_events';
import RegisterHuman from '../img/human_register.webp';
import RegisterHumanMobile from '../img/register_human_mobile.webp';
import showToast from '../helpers/toast';
import Auth from '../services/auth';
import { redirectUser } from '../actions/UserActions';
import Head from './head';
import Checkbox from './inputs/checkbox';

class Register extends React.Component {

  constructor() {
    super()
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.state = {
      email: '',
      password: '',
      phone: '',
      firstName: '',
      lastName: '',
      loading: false,
      address: '',
      city: '',
      state: '',
      zip: '',
      isMarketingChecked: true,
      country: 'United States',
      confirmPassword: '',
      captchaSuccess: false,
      captchaRequired: false,
    };
  }
    // Check if Token is already set
    componentWillMount() {
      const token = localStorage.getItem('token');
      if (token) {
        Auth.checkAuth().then(() => {
          
          redirectUser(token,"/", "");
        });
      }
  
    }
  register(e) {
    e.preventDefault();
    if(this.checkValidity() || !this.showFormErrors()){
      return;
    }
    this.setState({loading: true, captchaRequired: false});
    let data = {
      email: this.state.email,
      password: this.state.password,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.state.phone,
      zip: this.state.zip.toString(),
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      address: this.state.address
    };

    User.register(data)
      .then(() => {
        this.setState({loading: false});
        eventTracker('user_event', 'click', 'Register');
      })
      .catch((err) => {
        this.setState({loading: false});
        if(err.toString().indexOf('already exists') > -1){
          showToast('error', 'Email already exists');
        }
        else {
          showToast('error', 'Email already exists');

        }
      });
  }

  showFormErrors() {
    const inputs = document.querySelectorAll('input,select');
    let isFormValid = true;
    inputs.forEach(input => {
      const isInputValid = this.showInputError(input.name);
      if (!isInputValid) {
        isFormValid = false;
      }
    });

    if(!this.state.captchaSuccess){
      this.setState({captchaRequired: true});
      return false;
    }

    return isFormValid;
  }

  showInputError(refName) {
    if(!document.getElementById(`${refName}Label`) || !document.getElementById(`${refName}Error`) || !this.refs[refName].validity){
        return true;
    }
    const validity = this.refs[refName].validity;
    const label = document.getElementById(`${refName}Label`).textContent;
    const error = document.getElementById(`${refName}Error`);
    const isPassword = refName.indexOf('password') !== -1;
    const isDob = refName == 'dob';
    const isPasswordConfirm = refName === 'confirmPassword';

    if (isPasswordConfirm) {
      if (this.refs.password.state.password !== this.refs.confirmPassword.value) {
        this.refs.confirmPassword.setCustomValidity('Passwords do not match');
      } else {
        this.refs.confirmPassword.setCustomValidity('');
      }
    }
    if (!validity.valid) {
      if (validity.valueMissing) {
        error.textContent = `${label} is a required field`;
      } else if (validity.typeMismatch) {
        error.textContent = `${label} should be a valid email address`;
      } else if (refName === 'zip' && validity.patternMismatch) {
        error.textContent = `${label} is invalid`;
      } else if (isPassword && validity.patternMismatch) {
        error.textContent = `${label} should contain more than 5 characters including atleast 1 number, 1 special symbol, 1 upper case letter and 1 lower case letter`;
      } else if (isDob && validity.patternMismatch) {
        error.textContent = 'Date of birth is invalid';
      } else if (isPasswordConfirm && validity.customError) {
        error.textContent = 'Passwords do not match';
      }
      return false;
    }
    if(refName === 'email' && !this.emailRegex.test(String(this.refs.email.value).toLowerCase())) {
      error.textContent = `${label} should be a valid email address`;
      return false;
    }

    error.textContent = '';
    return true;
  }

  checkValidity(e){
    const phoneError = document.getElementById('phoneError');
    phoneError.textContent = '';
    let error = false;
    if(!this.state.phone){
      phoneError.textContent = 'Phone number is required'
      error = true;
    }
    if(this.state.phone && /\(\d{3}\)[\s.-]\d{3}[\s.-]\d{4}/.test(this.state.phone) === false) {
      phoneError.textContent = 'Phone number is invalid'
      error = true;
    }
    return error;
  }

  handleUserInput(e){
    this.setState({[e.target.name]: e.target.value});
    this.showInputError(e.target.name);
    if(e.target.name === 'phone' && !e.target.value) {
      const error = document.getElementById('phoneError');
      error.textContent = 'Phone number is required';
    }
    else if(e.target.name === 'phone' && e.target.value && /\(\d{3}\)[\s.-]\d{3}[\s.-]\d{4}/.test(e.target.value) === false) {
      const error = document.getElementById('phoneError');
      error.textContent = 'Phone number is invalid';
    }
    else if(e.target.name === 'phone') {
      const error = document.getElementById('phoneError');
      error.textContent = '';
    }
  }

  handlePassword(result){
    this.setState({password: result.password});
    const error = document.getElementById('passwordError');
    if(!result.password){
      error.textContent = 'Password is a required field';
    }
    else if(result.password.length < 6){
      error.textContent = 'Password must contain atleast 6 characters';
    }
    else{
      error.textContent = '';
    }
  }

  setCaptchaSuccess = (success) => {

    //if capctha is successful, required should be false
     this.setState({captchaSuccess: success, captchaRequired: !success})
  }

  render() {
    return (
      <div className="register-form">
        <Head title="Register - Tripper Bus" />

        <div className="clearfix">
          <div className="login-wrapper">
            <div className="loginFormWrapper">
              <div className="loginForm">
              <div className="login-header">
              <a href={process.env.REACT_APP_HOME_DOMAIN_URL}>
                <SVGInline svg={'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 616.3 198" style="enable-background:new 0 0 616.3 198;" xml:space="preserve"><g><path class="st0" d="M135.4,30.6c5.1-0.7,11.2-0.9,15,3.1c3.4,3.9,3.2,9.6,2.6,14.5c-0.6,4.6-4.4,8.5-9,9c-4.6,0.4-9.9,0.6-13.5-2.8c-4-3.6-3.8-9.6-3.3-14.5C127.5,35.4,131,31.4,135.4,30.6z"></path><path class="st0" d="M4.1,41.5c22.6,0,45.2,0,67.8,0C72.2,51.7,72,61.9,72,72.1c-2.9,0-5.7,0-8.6-0.2c-1.4-4.9-3-9.7-4.4-14.6c-3.1,0-6.2,0-9.3,0c0,31.9,0,63.8,0,95.8c-7.8,0-15.6,0.1-23.4-0.1c0-31.9-0.1-63.7,0-95.6c-3-0.1-6-0.3-9.1,0c-2,4.7-3.2,9.7-4.8,14.6C9.6,72,6.8,72.1,4,72.1C4,61.9,3.8,51.7,4.1,41.5z"></path><g><path class="st0" d="M419.5,42.1c10.8-0.5,21.7-0.4,32.5-0.4c5.4,0.2,11.3,0.3,16,3.4c6.7,4.2,10.2,12.1,10.9,19.8 c0.7,7.9,0.1,16.5-4.6,23.2c-2.1,3.2-5.2,5.4-8.2,7.5c7.6,3.2,13,10.5,14.4,18.6c1.4,8.1,0.8,16.8-3.2,24.1 c-3.7,7.2-10.9,12.9-19.1,13.8c-9,1.2-18.1,0.2-27.2,0.8c-3.8,0.2-7.7,0.2-11.5,0C419.5,116,419.6,79,419.5,42.1z M443.3,57.2 c-0.1,10.5-0.1,21,0,31.6c4.2-0.2,9.1-1.5,10.5-6c2-6.6,2-13.9-0.1-20.5C452.3,57.9,447.3,57.1,443.3,57.2z M443.3,103.9 c0,11,0,22,0,33.1c4.4,0.3,9.7-0.8,11.2-5.6c2.2-7,2.5-14.9-0.1-21.8C452.7,105.1,447.6,104,443.3,103.9z"></path> </g> <path class="st0" d="M77.7,64.9c7.7-1.5,15.3-3,22.9-4.5c0.1,2.9,0.1,5.8,0.1,8.7c3.1-3.3,6.6-6.9,11.3-7.3 c3.3-0.5,6.5,0.5,9.5,1.9c0,9.8,0,19.6,0,29.4c-3.2-2.3-6.1-5-9.5-7.1c-3.4-2.1-7.4-2.3-11.3-2.8c0,23.3,0,46.5,0,69.8 c-7.7,0.3-15.3,0.1-23,0.1C77.7,123.7,77.8,94.3,77.7,64.9z"></path> <path class="st0" d="M129.1,64.5c7.6-1.2,15.2-2.6,22.8-4c0.3,30.9,0.2,61.7,0.1,92.6c-7.7,0-15.4,0.1-23-0.1 C129.1,123.5,128.7,94,129.1,64.5z"></path> <path class="st0" d="M366.5,64.8c7.7-1.3,15.3-3,22.9-4.4c0,2.9,0,5.8,0,8.7c3.2-3.3,6.7-7.1,11.6-7.4c3.3-0.4,6.5,0.6,9.4,2.1 c0,9.8,0,19.6,0,29.4c-3.1-2.1-5.9-4.6-9-6.8c-3.5-2.4-7.8-2.8-11.9-3.1c-0.1,23.2,0,46.5,0,69.7c-7.7,0.3-15.4,0.3-23,0 C366.5,123.5,366.4,94.2,366.5,64.8z"></path> <path class="st0" d="M525.1,64.7c7.6-1.3,15-3,22.6-4.4c0.1,30.9,0,61.8,0,92.7c-7.6,0-15.2,0.1-22.8-0.1c0-2,0-3.9,0-5.9 c-6,3.4-12.5,7.7-19.8,6.3c-6.3-1.3-10.7-6.9-12.8-12.6c-2-5.7-2.1-11.8-2.1-17.8c0.1-19.3,0-38.6,0.1-57.9 c7.6-1.5,15.2-3.2,22.8-4.7c0,17.2,0,34.4,0,51.6c0.1,5.5-0.3,11.1,0.6,16.5c1.2,4.9,7.3,3.9,11.1,4.3 C525.2,110.1,524.6,87.4,525.1,64.7z"></path> <g> <path class="st0" d="M162.1,64.2c7.7-1.1,15.3-2.4,22.9-3.7c0,2.4,0,4.8,0,7.2c5.1-3.1,10.5-6.7,16.8-5.9 c8.4,0.5,14.2,7.9,17.3,15.1c5.3,12.8,6,27.1,4,40.6c-1.9,11.3-6.3,22.9-15.2,30.6c-6.2,5.4-14.9,7.8-22.9,5.7 c0,11.3,0,22.5,0,33.8c-7.7,0.1-15.4,0-23.1,0C162.1,146.4,161.7,105.3,162.1,64.2z M185.1,81.4c-0.1,18.9-0.2,37.8,0.1,56.6 c4-0.5,8-2.4,10.1-6c4.4-7.2,4.5-15.9,4.6-24.1c-0.3-7.5-0.4-15.7-4.9-22C192.8,82.7,188.9,81.6,185.1,81.4z"></path> </g> <g> <path class="st0" d="M231.3,64.3c7.7-1.2,15.3-2.5,23-3.8c0,2.7,0,5.5,0.1,8.2c0.5-0.6,0.9-1.2,1.3-1.8c5.3-3.5,11.7-6.5,18.2-4.7 c8.8,2.4,13.6,11.3,16.3,19.3c4.1,13.8,4.3,28.7,0.8,42.6c-2.9,11-8.9,22.3-19.4,27.6c-5.3,2.9-11.5,3.1-17.3,2.3 c0,11.1,0,22.3,0,33.4c-7.7,0.1-15.3,0-23,0.1C231.3,146.4,231.3,105.3,231.3,64.3z M254.4,138c3.9-0.5,7.9-2.2,10-5.7 c4.6-7.2,4.6-16.1,4.9-24.4c-0.6-7.7-0.3-16.3-5.5-22.6c-2.2-2.9-5.9-3.6-9.3-4.1C254.1,100.2,254.3,119.1,254.4,138z"></path> </g> <path class="st0" d="M561.9,71c3.7-5.7,10.2-9.3,17-9.3c8.4-0.4,16.6,2,24.6,4.4c0.2,5.3,0.3,10.5,0.2,15.8 c-6.3-3-12.7-6.4-19.8-6.7c-5.8,0.1-7.8,8-4.2,11.8c6.6,7.1,15.3,12.2,21,20.2c5.6,7.8,5.6,18.3,3.7,27.3 c-2.1,9.6-9.7,18.4-19.9,19.6c-9.7,0.9-19-2.8-28.1-5.5c-0.1-5.9,0.2-11.8,0.3-17.7c5.5,4,11.6,7.6,18.3,8.7 c4.4,0.8,9.8-1.9,10.2-6.7c0.4-5-4-8.1-7.2-11.1c-7.5-7.1-17.1-13.3-19.9-23.8C556.3,89.1,556.7,78.9,561.9,71z"></path> <g> <path class="st0" d="M314.7,68.7c6.7-6.7,17.3-8.8,26.2-5.6c7,2.6,11.5,9.1,14.6,15.5c3.4,8.6,2.7,18.1,2.8,27.2 c-11.4,1.7-22.8,3.4-34.2,4.9c0.6,8.1,3.1,17.3,10.7,21.6c6.5,3.6,14.1,1.8,20.9,0.1c0.7,5.1,1.2,10.2,1.9,15.3 c-9.9,3-19.8,7.6-30.4,6.7c-8.2-0.6-15.3-6.1-19.3-13.1c-6.6-11.1-7.8-24.5-6.9-37.2C301.9,91.3,305.3,77.9,314.7,68.7z M326.6,78.5c-3.3,5.4-2.7,12-2.9,18.1c4.1-0.7,8.2-1.4,12.3-2.2c-0.1-5.2,0.5-10.7-1.5-15.6C333.2,75.5,328.2,75.5,326.6,78.5z"></path> </g> </g> </svg>'} />
              </a>
            </div>
                <form name="loginForm">
                  <h4>Register Your Account</h4>
                  <p className='subtitle'>Book faster, earn points after every trip and more.</p>

                  {/*
                  <div className="form-group">
                    <label id="addressLabel">Address<span className='required'>*</span></label>
                    <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.address} name="address" ref="address" required className="form-control" placeholder="" />
                    <div className="error" id="addressError" />
                  </div>
                  <div className="form-group">
                    <label id="cityLabel">City<span className='required'>*</span></label>
                    <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.city} name="city" ref="city" required className="form-control" placeholder="" />
                    <div className="error" id="cityError" />
                  </div>
                  <div className="form-group">
                    <label id="stateLabel">State<span className='required'>*</span></label>
                    <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.state} name="state" ref="state" required className="form-control" placeholder="" />
                    <div className="error" id="stateError" />
                  </div>
                  <div className="form-group">
                    <label id="countryLabel">Country<span className='required'>*</span></label>
                    <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.country} name="country" ref="country" required className="form-control" placeholder="" />
                    <div className="error" id="countryError" />
                  </div> */}
                  <div className="form-group relative-form-group">
                    <label  className="formLable" id="emailLabel">E-mail</label>
                    <input type="email" onChange={this.handleUserInput.bind(this)} value={this.state.email} name="email" ref="email" required className="form-control" placeholder="" />
                    <div className="error" id="emailError" />
                  </div>
                  <div className='row'>
                    <div className="form-group col-sm-12 col-md-6">
                      <label className="formLable" id="firstNameLabel">First Name</label>
                      <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.firstName} name="firstName" ref="firstName" required className="form-control" placeholder="" />
                      <div className="error" id="firstNameError" />
                    </div>
                    <div className="form-group col-sm-12 col-md-6">
                      <label className="formLable" id="lastNameLabel">Last Name</label>
                      <input type="text" onChange={this.handleUserInput.bind(this)} value={this.state.lastName} name="lastName" ref="lastName" required className="form-control" placeholder="" />
                      <div className="error" id="lastNameError" />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="form-group relative-form-group col-sm-12 col-md-6">
                      <label  className="formLable" id="phoneLabel">Phone Number</label>
                      <InputMask mask="(999) 999-9999" ref="phone" onChange={this.handleUserInput.bind(this)} value={this.state.phone} name="phone" className="form-control" placeholder="" />
                      <div className="error" id="phoneError" />
                    </div>
                    <div className="form-group relative-form-group col-sm-12 col-md-6">
                      <label  className="formLable" id="zipLabel">Zip Code</label>
                      <input inputMode="numeric" pattern="(\d{5}([\-]\d{4})?)" onChange={this.handleUserInput.bind(this)} value={this.state.zip} name="zip" ref="zip" required className="form-control" placeholder="" />
                      <div className="error" id="zipError" />
                    </div>
                  </div>


                  <div className="form-group relative-form-group">
                    <label  className="formLable" id="passwordLabel">Password</label>
                    <ReactPasswordStrength
                      style={{border: 'none'}}
                      ref='password'
                      minLength={6}
                      changeCallback={this.handlePassword.bind(this)}
                      inputProps={{ name: 'password', autoComplete: 'off', className: 'form-control', required: 'true' }}
                    />
                    <div className="strong-password">Try to use an uppercase letter, a number and a special character to create a strong password.</div>
                    <div className="error" id="passwordError" />
                  </div>
                  <div className="form-group relative-form-group">
                    <label  className="formLable" id="confirmPasswordLabel">Confirm Password</label>
                    <input type="password" ref="confirmPassword" onChange={this.handleUserInput.bind(this)} name="confirmPassword" value={this.state.confirmPassword} required className="form-control" placeholder="" />
                    <div className="error" id="confirmPasswordError" />
                  </div>
                  <Checkbox onChange={(value)=>{
                    this.setState({isMarketingChecked: value});
                  }} checked={this.state.isMarketingChecked} label="I agree to receive text messages from Tripper Bus with updates regarding my reservation" />


                  {this.state.captchaRequired && <div className="error">Please Verify Captcha</div>}

                  <div className="form-group relative-form-group">
                      <Captcha setCaptchaSuccess={this.setCaptchaSuccess}/>
                    <button className="btn btn-blue" disabled={this.state.loading} onClick={this.register.bind(this)}>Register Account</button>
                  </div>

                 <div className='center'>  Already a user? <Link className="register-link" to="/login">Sign in.</Link> </div>
                </form>
              </div>
              <div className="bgRegisterLeft" >
                <img src={RegisterHuman} width="100%" height="100%" alt="Woman traveler ready for bus booking registration"/>
              </div>
              <div className="bgRegisterLeftMobile">
               <img src={RegisterHumanMobile} width="100%" height="100%" alt="Woman traveler ready for bus booking registration"/>
              </div>
              <div className='copyright'>
             © 2023 TripperBus. All Rights Reserved
            </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;
